import { render, staticRenderFns } from "./DataStructure.vue?vue&type=template&id=2c0a942a&scoped=true&"
import script from "./DataStructure.vue?vue&type=script&lang=js&"
export * from "./DataStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a942a",
  null
  
)

export default component.exports